// KEEP IN SYNC WITH DEVICE!
export class InputState
{
    constructor(
        public Name: string, 
        public Value: number) 
    { }
}
